import { useEffect } from "react";
import { useTest } from "../context/TestContext";

function Timer({ onTimeExpired }) {
  const { timeLeft, setTimeLeft, isPaused, setIsPaused } = useTest();

  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      setTimeLeft(t => {
        if (t <= 1) {
          onTimeExpired();
          return 0;
        }
        return t - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isPaused, onTimeExpired]);

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  return (
    <div>
      <h3>{formatTime(timeLeft)}</h3>
    </div>
  );
}

export default Timer;
